import React, { useState } from 'react';
import './index.css';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { useNavigate } from 'react-router-dom';
import { Button, ListGroup, Modal, Spinner } from 'react-bootstrap';
import { BsCheckCircleFill, BsChevronDown, BsFillCircleFill } from 'react-icons/bs';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase';
import { useAuth } from '../../../context/AuthContext';

function Datatable({ columns, data }) {

  const { user } = useAuth();
  const { bid } = user.claims;

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);

  async function updateStatus(dataItem) {
    setIsLoading(true);
    const { id, status } = dataItem;

    const docRef = doc(db, "Businesses", bid, "Leads", id);
    await updateDoc(docRef, {
      status: status,
      updatedAt: new Date()
    });

    setShowStatusModal(false);
    setIsLoading(false);
    setSelected(null);
  }

  return (
    <div className='lead-datatable h-auto border rounded'>
      <table className='table mb-0'>
        <thead className='table-head sticky-top'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 || index === columns.length - 3 ? 'text-start bg-table-head px-4' : 'text-center bg-table-head px-4'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((item, index) => {
                  return (
                    <tr key={index} className='border-top'>
                      <td
                        className={`align-middle px-4 cursor-pointer text-start ${item.status === 'Lost' ? 'text-danger' : 'text-primary'}`}
                        onClick={() => navigate(`details/${item.id}`)}
                      >
                        {item && item.name}
                      </td>
                      <td className="align-middle px-4 text-center">{item?.type || '-'}</td>
                      <td className="align-middle px-4 text-center">{item?.source || '-'}</td>
                      <td className="align-middle px-4 text-center">+91 {item.phoneNumber}</td>
                      <td className="align-middle px-4 text-start">{item?.email || '-'}</td>
                      <td className='align-middle px-4 text-center'>{new Date(item && item.createdAt.seconds * 1000).toLocaleDateString("es-CL")}</td>
                      <td className="align-middle px-4 py-2 text-end">
                        <Button
                          variant='outline-light'
                          className='border text-dark py-2 px-3 w-100'
                          onClick={() => {
                            setSelected(item);
                            setShowStatusModal(true);
                          }}
                        >
                          <div className='w-100 d-flex align-items-center justify-content-between'>
                            <div className='w-100 d-flex align-items-center justify-content-start'>
                              <BsFillCircleFill
                                size={8}
                                color={item.status === 'New' ?
                                  `var(--bs-primary)`
                                  : item.status === 'Contacted' ?
                                    `var(--bs-warning)`
                                    : item.status === 'Site Visit Done' ?
                                      `var(--bs-info)`
                                      : item.status === 'Converted' ?
                                        `var(--bs-success)`
                                        : `var(--bs-danger)`
                                }
                              />
                              <span className='ps-3'>
                                {item?.status || '-'}
                              </span>
                            </div>
                            <BsChevronDown size={12} />
                          </div>
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={8}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>

      <Modal
        show={showStatusModal}
        onHide={() => setShowStatusModal(false)}
        backdrop="static"
        centered={true}
      >
        <div className='modal-header border-bottom-0'>
          <h5 className='mb-0'>Update Status</h5>
          <Button variant='none' className='btn-close px-3' onClick={() => setShowStatusModal(false)} />
        </div>
        <div className='modal-body p-0'>
          <ListGroup>
            {
              [
                { name: "New", color: "var(--bs-primary)" },
                { name: "Contacted", color: "var(--bs-warning)" },
                { name: "Site Visit Done", color: "var(--bs-info)" },
                { name: "Converted", color: "var(--bs-success)" },
                { name: "Lost", color: "var(--bs-danger)" }
              ].map((item, index) => {
                return (
                  <ListGroup.Item
                    key={index}
                    action
                    className='rounded-0 py-2 px-4 d-flex align-items-center justify-content-between'
                    onClick={() => setSelected({ ...selected, status: item.name })}
                  >
                    <div className='d-flex align-items-center'>
                      <BsFillCircleFill size={8} color={item.color} />
                      <div className='py-2 ms-3'>{item.name}</div>
                    </div>
                    {
                      selected && selected.status === item.name ?
                        <div>
                          <BsCheckCircleFill size={18} color="var(--bs-info)" />
                        </div>
                        :
                        null
                    }
                  </ListGroup.Item>
                )
              })
            }
          </ListGroup>
        </div>
        <div className='modal-footer border-top-0 px-3 align-items-center justify-content-between'>
          <Button
            variant="outline-danger"
            onClick={() => setShowStatusModal(false)}
            className='px-5 py-2'
          >
            Cancel
          </Button>
          <Button
            disabled={isLoading}
            variant="primary"
            className='px-5 py-2 btn-width'
            onClick={() => updateStatus(selected)}
          >
            {
              isLoading ?
                <Spinner />
                :
                "Update"
            }
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default Datatable;